import { render } from "./FileUploadInput.vue?vue&type=template&id=0511e208&scoped=true"
import script from "./FileUploadInput.vue?vue&type=script&lang=js"
export * from "./FileUploadInput.vue?vue&type=script&lang=js"

import "./FileUploadInput.vue?vue&type=style&index=0&id=0511e208&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0511e208"]])

export default __exports__